module.exports = __webpack_public_path__ + "img/region_sierra.68242374.svg";